import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { cssVar } from 'src/app/styles/helper';
import styled from 'styled-components';

export const PriceBlockContainer = styled(Stack)`
  border-bottom: 1px solid ${cssVar('border-secondary')};
  height: fit-content;

  .period {
    margin-bottom: ${cssVar('spacing-xl')};
  }
`;
